import React, { createContext } from "react";
const DisplayOptionsContext = createContext(null);
DisplayOptionsContext.displayName = "DisplayOptionsContext";
const DisplayOptionsProvider = ({ displayOptions, children }) => {
  return /* @__PURE__ */ React.createElement(DisplayOptionsContext.Provider, {
    value: displayOptions
  }, children);
};
var DisplayOptionsProvider_default = DisplayOptionsProvider;
export {
  DisplayOptionsContext,
  DisplayOptionsProvider_default as default
};
